import { Stack as MuiStack, type StackProps as MuiStackProps } from '@mui/material';

import type { FlexAlignItems, FlexJustifyContent } from '../../../types/FlexAlignment';
import type { BreakpointValues, Responsive } from '../../../types/Responsive';
import type { NO_SPACING, Spacing } from '../../../types/Spacing';
import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type StackDirection = Extract<NonNullable<MuiStackProps['direction']>, string>;

type StackWrap = 'nowrap' | 'wrap';

type LayoutProps = {
  direction?: Responsive<StackDirection>;
  spacing?: Spacing | BreakpointValues<Spacing | typeof NO_SPACING>;
  alignItems?: Responsive<FlexAlignItems>;
  justifyContent?: Responsive<FlexJustifyContent>;
  wrap?: Responsive<StackWrap>;
};

type Props = WithoutStyleOverrides<Omit<MuiStackProps, keyof LayoutProps | 'useFlexGap'>> & LayoutProps;

export function Stack(props: Props) {
  const { alignItems, justifyContent, wrap, ...stackProps } = props;

  return <MuiStack {...stackProps} useFlexGap sx={{ alignItems, justifyContent, flexWrap: wrap }} />;
}

export type { Props as StackProps };
